// import React from "react";
// import styles from "./steper.module.css";
// import clsx from "clsx";
// import { useDispatch, useSelector } from "react-redux";
// import { setStep } from "../../store/reducers/stepReducer";
// import useHasPermission from "../../hooks/useHasPermission";
// interface Props {
//   step: number;
//   stepTitles: string[];
//   onNavigateToStep?: (step: number) => void;
// }
// const Stepline = ({ onNavigateToStep, step, stepTitles }: Props) => {
//   const { hasPermission } = useHasPermission();
//   const dispatch = useDispatch();
//   const { step: currentStep, completedStep } = useSelector(
//     (state: any) => state.steps
//   );
//   console.log(completedStep, "completedstep");

//   const stepData = [
//     "",
//     "VIDEO",
//     "PRESENTATION",
//     "BENEFITS CALCULATOR",
//     // "RESOURCE LIBRARY",
//     // `CPA CALL`,
//   ];
//   const totalSteps = 4;
//   const range = (start: number, end: number) => {
//     return Array.from({ length: end - start + 1 }, (_, index) => start + index);
//   };

//   const handleStepClick = (stepNumber: number) => {
//     if (stepNumber <= completedStep) {
//       if (onNavigateToStep) {
//         onNavigateToStep(stepNumber);
//         dispatch(setStep(stepNumber));
//       }
//     }
//   };

//   return (
//     <div
//       className={`${styles.container} ${
//         step === 3
//           ? "lg:w-[50vw] w-[90vw]"
//           : "lg:w-[40vw] w-[100vw] px-6 lg:px-0"
//       }`}
//     >
//       {range(2, totalSteps).map((item, index) => {
//         const isCompleted = item <= completedStep;
//         const isCurrent = item === currentStep;
//         const isLastStep = index === totalSteps - 1;

//         return (
//           <div
//             key={item}
//             className={`${styles.container} ${
//               isLastStep ? "" : styles.stepMargin
//             } ${step === 3 ? "lg:w-[50vw] w-[90vw]" : "w-[40vw]"}`}
//             onClick={() => handleStepClick(item)}
//           >
//             <div
//               className={clsx(styles.step, {
//                 [styles.completed]: isCompleted,
//                 [styles.current]: isCurrent,
//                 [styles.pending]: item > currentStep,
//               })}
//             >
//               <div
//                 className={
//                   isCompleted
//                     ? styles.innerCircle
//                     : styles.innerCircleIncomplete
//                 }
//               >
//                 {isCompleted ? (
//                   <div className="h-20 mt-28 text-center lg:text-[13.5px] text-[10px]">
//                     <span className={styles.stepData}>
//                       {stepData[item - 1]}
//                     </span>
//                   </div>
//                 ) : (
//                   <div className="h-20 mt-28 text-center w-[200px] lg:text-[13.5px] text-[10px]">
//                     <span className={styles.stepDataIncomplete}>
//                       {stepData[item - 1]}
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </div>
//             {item < totalSteps && (
//               <span
//                 className={clsx(styles.line, {
//                   [styles.completedLine]: item <= completedStep,
//                   [styles.pendingLine]: item > completedStep,
//                 })}
//               ></span>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default Stepline;

import React from "react";
import styles from "./steper.module.css";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { setStep } from "../../store/reducers/stepReducer";
import useHasPermission from "../../hooks/useHasPermission";

interface Props {
  step: number;
  stepTitles: string[];
  onNavigateToStep?: (step: number) => void;
}

interface StepConfig {
  title: string;
  permissionKey: keyof ITilePermissions;
  stepNumber: number;
}

const Stepline = ({ onNavigateToStep, step, stepTitles }: Props) => {
  const { hasPermission } = useHasPermission();
  const dispatch = useDispatch();
  const { step: currentStep, completedStep } = useSelector(
    (state: any) => state.steps
  );
  const stepConfigs: StepConfig[] = [
    { title: "VIDEO", permissionKey: "video", stepNumber: 2 },
    { title: "PRESENTATION", permissionKey: "presentation", stepNumber: 3 },
    {
      title: "BENEFITS CALCULATOR",
      permissionKey: "benefitCalculator",
      stepNumber: 4,
    },
  ];

  const availableSteps = stepConfigs.filter((stepConfig) =>
    hasPermission(stepConfig.permissionKey)
  );

  const adjustedSteps = availableSteps.map((stepConfig, index) => ({
    ...stepConfig,
    adjustedStepNumber: index + 2,
  }));

  const handleStepClick = (stepConfig: any) => {
    if (stepConfig.stepNumber <= completedStep && onNavigateToStep) {
      onNavigateToStep(stepConfig.stepNumber);
      dispatch(setStep(stepConfig.stepNumber));
    }
  };

  return (
    <div
      className={`${styles.container} ${
        step === 3
          ? "lg:w-[50vw] w-[90vw]"
          : "lg:w-[40vw] w-[100vw] px-6 lg:px-0"
      }`}
    >
      {adjustedSteps.map((stepConfig, index) => {
        const isCompleted = stepConfig.stepNumber <= completedStep;
        const isCurrent = stepConfig.stepNumber === currentStep;
        const isLastStep = index === adjustedSteps.length - 1;

        return (
          <div
            key={stepConfig.stepNumber}
            className={`${styles.container} ${
              isLastStep ? "" : styles.stepMargin
            } ${step === 3 ? "lg:w-[50vw] w-[90vw]" : "w-[40vw]"}`}
            onClick={() => handleStepClick(stepConfig)}
          >
            <div
              className={clsx(styles.step, {
                [styles.completed]: isCompleted,
                [styles.current]: isCurrent,
                [styles.pending]: stepConfig.stepNumber > currentStep,
              })}
            >
              <div
                className={
                  isCompleted
                    ? styles.innerCircle
                    : styles.innerCircleIncomplete
                }
              >
                {isCompleted ? (
                  <div className="h-20 mt-28 text-center lg:text-[13.5px] text-[10px]">
                    <span className={styles.stepData}>{stepConfig.title}</span>
                  </div>
                ) : (
                  <div className="h-20 mt-28 text-center w-[200px] lg:text-[13.5px] text-[10px]">
                    <span className={styles.stepDataIncomplete}>
                      {stepConfig.title}
                    </span>
                  </div>
                )}
              </div>
            </div>
            {!isLastStep && (
              <span
                className={clsx(styles.line, {
                  [styles.completedLine]:
                    stepConfig.stepNumber <= completedStep,
                  [styles.pendingLine]: stepConfig.stepNumber > completedStep,
                })}
              ></span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Stepline;
